"use client";
import { useProfile } from "@/hooks/user/useProfile";
import { Card, Space, Typography } from "antd";
import { useTranslation } from "react-i18next";

const { Text, Title } = Typography;

export const memberLabel: any = {
  Member: "common.new",
  Silver: "common.silver",
  Gold: "common.gold",
  Platinum: "common.diamond"
}

const nextLevel: any = {
  Member: "common.silver",
  Silver: "common.gold",
  Gold: "common.diamond"
}

const levelMin: any = {
  Member: 0,
  Gold: 30000000,
  Silver: 1000000,
  Platinum: 50000000,
}

const levelPoint: any = {
  Member: 5,
  Gold: 7,
  Silver: 5,
  Platinum: 10,
}

const LoyaltyProgram = () => {
  // This would typically come from an API or context
  const profile = useProfile()
  const { t } = useTranslation()

  const membershipData = {
    level: t(memberLabel[profile?.membershipData?.membershipLevel]),
    currentPoints: profile?.memberPointData?.activePoint,
    pointsToNextLevel: profile?.memberPointData?.activePoint,
    nextLevel: t(nextLevel[profile?.membershipData?.membershipLevel]),
  };

  const thePointNeeded = (
    levelPoint[profile?.membershipData?.membershipLevel] *
    (
      Math.floor(levelMin[membershipData?.nextLevel] / 1000000) -
      Math.floor(levelMin[profile?.membershipData?.membershipLevel] / 1000000)
    )
  ) - membershipData?.currentPoints

  return (
    <>
      <Card
        style={{
          borderRadius: "12px",
        }}
        title={t("app.loyal_customer")}
        variant='borderless'
      >
        <Title
          level={1}
          style={{
            fontSize: 18,
            fontWeight: 600,
            marginBottom: 8,
          }}
        >
          {t("common.member")} {membershipData.level}
        </Title>
        <Space
          direction="vertical"
          style={{
            width: "100%",
          }}
        >
          <Text>{t("profile.current_points")}: {membershipData.currentPoints} {t("common.point")}</Text>
          {memberLabel[membershipData.nextLevel] && (
            <Text style={{ marginTop: 16 }}>
              {t("profile.next_level_note", { thePointNeeded, nextLevel: t(memberLabel[membershipData.nextLevel]) })}
            </Text>
          )}
        </Space>
      </Card>
    </>
  );
};

export default LoyaltyProgram;
